export type PanelVariant = 'solid' | 'glass' | 'accent';
export type PanelPadding = 'none' | 'sm' | 'md' | 'lg';

/** Shared by Panel, Card, Modal and Popover so their surfaces never drift apart. */
export const PANEL_VARIANT_CLASSES: Record<PanelVariant, string> = {
    solid: 'bg-space-800 border border-space-700 rounded-panel',
    glass: 'bg-surface-panel backdrop-blur-panel border border-hairline rounded-panel shadow-e4',
    accent: 'bg-surface-panel backdrop-blur-panel rounded-panel shadow-e4 border-[1.5px] border-[color:var(--zone-accent)]',
};

export const PANEL_PADDING_CLASSES: Record<PanelPadding, string> = {
    none: '',
    sm: 'p-3',
    md: 'p-4',
    lg: 'p-6',
};
